/* eslint ember/no-new-mixins:"off" */

// All components that are designed to be inside a `SqFormFieldComponent` should extend this mixin. It sets up basic communication
// between the inner form components and outer Form Field level block component.

import { alias } from '@ember/object/computed';
import Mixin from '@ember/object/mixin';
import { computed } from '@ember/object';
import $ from 'jquery';
export default Mixin.create({
  isDisabled: alias('disabled'),
  isFocused: false,
  isInvalid: alias('invalid'),
  isReadOnly: alias('readOnly'),
  parentLabel: computed('element', function () {
    // eslint-disable-next-line ember/no-jquery
    return $(this.element).parents('.form-field__content').siblings('.form-field__label');
  }),
  parentField: null,
  // `{{sq-form-field}}` applies the invalid CSS class at the outer field level,
  // so we don't want to apply the default `input-is-invalid` class here.
  invalidClass: null,
  init(...args) {
    this._super(...args);

    // managedFields is only a property when the parent view is a Form Field component. While 95% of the time we expect that
    // this is the case, we still want components that use this mixin to work independently and not break.
    // The parent field can also be passed in explicitly

    let parentField = this.get('parentField');
    if (!parentField && typeof this.get('parentView.managedFields') === 'object') {
      parentField = this.get('parentView');
      this.set('parentField', parentField);
    }
    if (parentField) {
      parentField.addManagedField(this);
    }
  },
  didInsertElement(...args) {
    this._super(...args);

    // If there is no parent field, don't try to interact with it at all
    if (!this.get('parentField')) {
      return;
    }

    // If this is already set then there are multiple inputs, so we just return and
    // allow the first input to continue receiving focus
    if (this.get('parentField.innerElementId')) {
      return;
    }

    // eslint-disable-next-line ember/no-jquery
    const childId = $(this.element).children().filter(':input').attr('id');
    if (childId) {
      this.set('parentField.innerElementId', childId);
    } else if (['input', 'textarea', 'select'].includes(this.get('tagName'))) {
      this.set('parentField.innerElementId', this.get('elementId'));

      // TODO (nschaden): is traversing DOM with jQuery to find a label and add a click event efficient?
    } else {
      const inputs = $(this.element).find('button,input,textarea,select'); // eslint-disable-line ember/no-jquery
      if (inputs.length > 0 && this.get('parentLabel.length')) {
        const firstInput = inputs.first();

        // [UI-28] This check prevents clicking label from toggling first checkbox in a form field
        if (!firstInput.is('input[type=checkbox]')) {
          this.set('parentField.innerElementId', firstInput.attr('id'));
        }
        this.get('parentLabel').on('click.labelOverride', () => firstInput.focus());
      }
    }
  },
  willDestroyElement(...args) {
    this._super(...args);
    if (this.get('parentLabel.length')) {
      this.get('parentLabel').off('click.labelOverride');
    }
    const parentField = this.get('parentField');
    if (parentField) {
      parentField.removeManagedField(this);
    }
  },
  focusIn(...args) {
    this.set('isFocused', true);
    if (this.onFocusIn) {
      this.onFocusIn(...args);
    }
  },
  focusOut(...args) {
    this.set('isFocused', false);
    if (this.onFocusOut) {
      this.onFocusOut(...args);
    }
  }
});